import { useState } from 'react';

import { useLocation, useNavigate, useParams } from 'react-router-dom';

import useFeatureFlags from 'api/useFeatureFlags';
import { analyticsTabsLabelsMap, EAnalyticsState } from 'constants/navigation';
import { Analytics } from 'design-system/AcSidebar/constants';
import { TabsPanel } from 'design-system/TabPanel/TabPanel';
import { useTabTracking } from 'hooks/useTabTracking';

import PageTopBar from 'components/Topbar/PageTopBar';

const AnalyticsView: React.FC = () => {
  const { publisherId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const currentPath = location.pathname;
  const getCurrentTab = (): EAnalyticsState => {
    if (currentPath.includes('/finance')) return EAnalyticsState.FINANCE;
    if (currentPath.includes('/ab-test')) return EAnalyticsState.AB_TEST;
    return EAnalyticsState.BUSINESS;
  };

  const [tab, setTab] = useState<EAnalyticsState>(getCurrentTab());
  const { featureFlags } = useFeatureFlags({ publisherId });

  const basePath = `/project/${publisherId}`;
  const getAnalyticsPath = (basePath: string, state: EAnalyticsState) =>
    `${basePath}/statistics/${state}`;

  const tabs = [
    { label: analyticsTabsLabelsMap[EAnalyticsState.BUSINESS], value: EAnalyticsState.BUSINESS },
    { label: analyticsTabsLabelsMap[EAnalyticsState.FINANCE], value: EAnalyticsState.FINANCE },
    { label: analyticsTabsLabelsMap[EAnalyticsState.AB_TEST], value: EAnalyticsState.AB_TEST },
  ];

  const { handleTabChangeWithEvent } = useTabTracking({
    sidebarTab: Analytics.title,
    tabs,
    customNavigate: (newValue) => {
      setTab(newValue as EAnalyticsState);
      navigate(getAnalyticsPath(basePath, newValue as EAnalyticsState));
    }
  });

  if (featureFlags === undefined) {
    return <></>;
  }

  return (
    <TabsPanel
      tabs={tabs}
      headerComponent={<PageTopBar withTabsDesign={true} headline="Analytics" />}
      handleTabChange={handleTabChangeWithEvent}
      activeTabVal={tab}
    />
  );
};

export default AnalyticsView;
